import { show } from "~/api/contractSpendingTotal";
import * as types from "../mutation-types";
import store from "../../store";

export const state = {
    seriesData: [],
    isLoading: false,
    totalDataByPeriod: {}
};

export const mutations = {
    SET_IS_LOADING_PIE_CHART(state, status) {
        state.isLoading = status;
    },
    SET_TOTAL_DATA_BY_PERIOD(state, data) {
        state.totalDataByPeriod = data;
    },
    SET_SERIES_PIE_CHART(state, data) {
        let result = [];

        Object.entries(data).forEach(([key, value]) => {
            let seriesName;
            switch (key) {
                case "10":
                    seriesName = "Витрати за сховище";
                    break;
                case "1":
                    seriesName = "Загальні витрати";
                    break;
                case "20":
                    seriesName = "Витрати БД";
                    break;
                case "30":
                    seriesName = "Запити до сайтів";
                    break;
                case "31":
                    seriesName = "Навантаження CPU  сайту";
                    break;
                case "32":
                    seriesName = "Використання  Memory сайту";
                    break;
                case "40":
                    seriesName = "Сертифікати";
                    break;
                case "50":
                    seriesName = "Планувальники";
                    break;
                case "60":
                    seriesName = "Домени";
                    break;
                default:
                    seriesName = key;
            }

            result.push({
                turboThreshold: 0,
                name: seriesName,
                data: value
            });
        });

        state.seriesData = result;
    }
};

export const actions = {
    fetchPieChartData({ commit }, data) {
        let activeContractId =
            data.contractId || store.getters["contract/activeContract"]?.id;

        if (activeContractId) {
            commit("SET_IS_LOADING_PIE_CHART", true);

            return show(activeContractId).then((response) => {
                if (response && response.data && response.data.data) {
                    commit("SET_TOTAL_DATA_BY_PERIOD", response.data.data);
                    commit("SET_SERIES_PIE_CHART", response.data.data);
                }
                commit("SET_IS_LOADING_PIE_CHART", false);
                return response;
            }).catch((error) => {
                commit("SET_IS_LOADING_PIE_CHART", false);
                throw error;
            });
        } else {
            commit("SET_IS_LOADING_PIE_CHART", false);
            return Promise.resolve();
        }
    }
};

export const getters = {
    seriesData: (state) => state.seriesData,
    isLoading: (state) => state.isLoading,
    totalDataByPeriod: (state) => state.totalDataByPeriod,
    dayTotal: (state) => state.totalDataByPeriod['1']?.totalCost || 0,
    weekTotal: (state) => state.totalDataByPeriod['2']?.totalCost || 0,
    monthTotal: (state) => state.totalDataByPeriod['3']?.totalCost || 0,
    generalTotal: (state) => state.totalDataByPeriod['4']?.totalCost || 0
}; 